import React, { useContext } from 'react';
import twMerge from 'utilities/src/twMerge';
import ThemeContext from './_themeContext';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function BackgroundWrapper({ children, className }: Props) {
  const { theme } = useContext(ThemeContext);
  return (
    <div
      className={twMerge(
        'transition-[background-color] duration-300',
        'mdS:bg-site-neutrals-25 bg-site-neutrals-800',
        {
          'mdS:bg-site-neutrals-900/80': theme === 'dark',
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
